import { Attrs, MinzeElement } from 'minze'

export interface LvcSliderArrowRightIcon {
  dataColor?: string
  width?: number
  height?: number
}

export class LvcSliderArrowRightIcon extends MinzeElement {
  attrs: Attrs = [['data-color'], ['width', 47], ['height', 47]]

  static observedAttributes = ['width', 'height']

  onAttributeChange(
    name?: string | undefined,
    oldValue?: string | null | undefined,
    newValue?: string | null | undefined
  ): void | Promise<void> {
    if (name === 'width' && newValue) {
      this.width = Number(newValue)
    }
    if (name === 'height' && newValue) {
      this.height = Number(newValue)
    }
  }

  html = () => `
    <svg width="${this.width}" height="${this.height}" viewBox="0 0 47 47" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M27.4815 23.5822C26.3875 23.6058 25.3826 23.6178 24.3722 23.6512C21.833 23.7307 19.2885 23.8173 16.7492 23.904C15.8435 23.9335 14.9378 23.963 14.0323 23.9781C13.7914 23.985 13.5456 23.9774 13.3115 23.8982C13.0981 23.8268 12.9294 23.5841 12.9922 23.2623C13.0321 23.0621 13.1562 22.8357 13.2886 22.7391C13.4317 22.6284 13.6252 22.6344 13.798 22.6254C14.5628 22.5771 15.3276 22.5289 16.0971 22.5096C19.7513 22.3999 23.4105 22.3047 27.0646 22.2022C27.1955 22.199 27.3324 22.1457 27.4636 22.121C27.6755 21.6455 27.5737 21.1531 27.6022 20.6935C27.6233 20.3632 27.6288 20.0252 27.6864 19.7032C27.7443 19.3669 28.1253 19.1053 28.3591 19.2061C28.4579 19.2451 28.5616 19.3059 28.644 19.3876C29.9463 20.7015 31.4182 21.5673 32.8788 22.4832C33.1585 22.6574 33.432 22.8889 33.6789 23.1484C33.9412 23.4299 33.9264 24.0123 33.6604 24.2774C33.4636 24.4728 33.2414 24.617 33.0194 24.754C31.6721 25.5468 30.3401 26.3617 29.0728 27.3801C28.8395 27.5671 28.5654 27.6881 28.2972 27.7661C27.9922 27.8574 27.7195 27.5755 27.7791 27.1313C27.8626 26.5079 27.5142 26.0582 27.55 25.4694C27.5856 24.8949 27.6212 24.3204 27.4815 23.5822Z" fill="${this.dataColor ? this.dataColor : '#1E007D'}"/>
    </svg>
  `

  css = () => `
    :host {
      width: ${this.width}px;
      height: ${this.height}px;
    }
  `
}
